/**
 * Property types and interfaces
 */
// Property types for categorization
export var PropertyType;
(function (PropertyType) {
    PropertyType["SINGLE_FAMILY"] = "SINGLE_FAMILY";
    PropertyType["MULTI_FAMILY"] = "MULTI_FAMILY";
    PropertyType["COMMERCIAL"] = "COMMERCIAL";
    PropertyType["MIXED_USE"] = "MIXED_USE";
    PropertyType["HOA"] = "HOA";
})(PropertyType || (PropertyType = {}));
// Property status
export var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["ACTIVE"] = "ACTIVE";
    PropertyStatus["INACTIVE"] = "INACTIVE";
})(PropertyStatus || (PropertyStatus = {}));
// Listing types for property listings
export var ListingType;
(function (ListingType) {
    ListingType["APARTMENT"] = "APARTMENT";
    ListingType["CONDO"] = "CONDO";
    ListingType["HOUSE"] = "HOUSE";
    ListingType["TOWNHOUSE"] = "TOWNHOUSE";
})(ListingType || (ListingType = {}));
/**
 * Response the agent gives when a caller asks about housing vouchers (Section 8)
 * and the listing does not mention them. Single source of truth so every agent
 * surface uses the same wording.
 */
export const HOUSING_VOUCHERS_NOT_LISTED_RESPONSE = "It seems like that information is not listed on here. I'll take a message for the team to confirm.";
/**
 * Return "{street}, {city}" for the voice agent to read aloud, or undefined
 * when either part is missing. State and postcode are intentionally omitted.
 */
export function computeListingShortAddress(listing) {
    if (listing.addressStreet1 && listing.addressCity) {
        return `${listing.addressStreet1}, ${listing.addressCity}`;
    }
    return undefined;
}
/**
 * Format an Address object for display
 * @param address - The address object to format
 * @returns Formatted address string: "street, city, state postcode"
 */
export function formatAddress(address) {
    const street = address.addressStreet2
        ? `${address.addressStreet1} ${address.addressStreet2}`
        : address.addressStreet1;
    return `${street}, ${address.addressCity}, ${address.addressState} ${address.addressPostcode}`;
}
//# sourceMappingURL=property.js.map